import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import entityJurisdictionInfoReducer from './entityJurisdictionInfo/entityJurisdictionInfo.reducer';
import { entityJurisdictionsDetailResetAction } from './entityJurisdictionsDetail.actions';
import filingTypesReducer from './filingTypes/filingTypes.reducer';

export const initialState = {};

const combinedReducers = combineReducers({
  info: entityJurisdictionInfoReducer,
  filingTypes: filingTypesReducer,
});

const entityJurisdictionsDetailReducer = createReducer(initialState, builder => {
  builder
    .addCase(entityJurisdictionsDetailResetAction.type, () => initialState)
    .addDefaultCase(() => {});
});

export default (state = initialState, action) => {
  const newState = entityJurisdictionsDetailReducer(state, action);
  return combinedReducers(newState, action);
};
